import React from 'react';
import { MegaSplash } from '../layout/MegaSplash';
import { Splash, SplashContent, SplashTitle } from '../layout/Splash';
import { Sectional } from 'layout/Sectional';

export const PathError: React.FC = () => {
    return (<>
        <Sectional title="404 Error">
                The page you're looking for either no longer exists, or it never did. Try going back to the <a href="/">homepage</a>, and navigate around to find what you're looking for.
        </Sectional>
    </>)
};

export default PathError;